import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCastle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"castle, sandbox, wall"} maskId="square-filled-radius-0-stroke-1-IconCastle"><path d="M8 5H10V3H14V5H16V3H20V5.48145L21.0342 21H14V16H10V21H2.96582L4 5.48145V3H8V5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCastle;
